import React, { useEffect, useRef } from 'react'
import GoldSiverHeader from '../../HomePage/GoldSiverHeader'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

function City() {
    const { t, i18n: i18nInstance } = useTranslation();
    const navigate = useNavigate();
    
    // Load saved language from localStorage on mount
    useEffect(() => {
        const savedLanguage = localStorage.getItem('language');
        if (savedLanguage && i18nInstance.language !== savedLanguage) {
            i18nInstance.changeLanguage(savedLanguage);
        }
    }, [i18nInstance]);
    
    const currentLanguage = i18nInstance.language || 'en';
    const isRTL = currentLanguage === 'he';
    const carouselRef = useRef(null);
    const dragStartRef = useRef(null);
    const isDraggingRef = useRef(false);
    
    // Handle click on carousel items
    const handleItemClick = (placeId, route, e) => {
        // Check if this was a drag or a click
        if (dragStartRef.current) {
            const deltaX = Math.abs(e.clientX - dragStartRef.current.x);
            const deltaY = Math.abs(e.clientY - dragStartRef.current.y);
            
            // If moved more than 5px, it was a drag
            if (deltaX > 5 || deltaY > 5) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
        }
        
        // It was a click, navigate
        navigate(route);
    };

    // רשימת המקומות בעיר עם תמונות ונתיבים
    const cityPlaces = [
        {
            id: 'hospital',
            image: '/images/town/hospital.png',
            route: '/hospital',
            titleKey: 'Hospital'
        },
        {
            id: 'gym',
            image: '/images/town/gym.png',
            route: '/gym',
            titleKey: 'Gym'
        },
        {
            id: 'travel',
            image: '/images/town/Travel.png',
            route: '/travel',
            titleKey: 'Travel'
        },
        {
            id: 'market',
            image: '/images/town/Market.png',
            route: '/market',
            titleKey: 'Market'
        },
        {
            id: 'fountain',
            image: '/images/town/townCoro.png',
            route: '/fountain',
            titleKey: 'Fountain'
        },
        {
            id: 'casino',
            image: '/images/town/townCoro.png',
            route: '/casino',
            titleKey: 'Casino'
        },
        {
            id: 'traders',
            image: '/images/town/townCoro.png',
            route: '/traders',
            titleKey: 'Traders'
        },
        {
            id: 'pokemart',
            image: '/images/town/townCoro.png',
            route: '/pokemart',
            titleKey: 'Pokemart'
        },
        {
            id: 'moves',
            image: '/images/town/townCoro.png',
            route: '/moves',
            titleKey: 'Moves'
        },
        {
            id: 'daycare',
            image: '/images/town/townCoro.png',
            route: '/daycare',
            titleKey: 'Daycare'
        },
        {
            id: 'pokemon-specialist',
            image: '/images/town/townCoro.png',
            route: '/others/pokemon-specialist',
            titleKey: 'Pokemon Specialist'
        },
        {
            id: 'transfer-value',
            image: '/images/town/townCoro.png',
            route: '/transfer-value',
            titleKey: 'Transfer Value'
        }
    ];

    // אתחול Owl Carousel
    useEffect(() => {
        let isMounted = true;
        let retryCount = 0;
        const maxRetries = 5;
        
        // קבלת השפה הנוכחית
        const currentLang = i18nInstance.language || 'en';
        const isRTLNow = currentLang === 'he';
        
        // טעינת CSS של Owl Carousel
        const loadCSS = () => {
            // הסר כל קישורי CSS קודמים של owl.carousel
            const existingLinks = document.querySelectorAll('link[href*="owl.carousel"], link[href*="owl.theme"]');
            existingLinks.forEach(link => {
                if (link.parentNode) {
                    link.parentNode.removeChild(link);
                }
            });
            
            // טען מ-CDN ישירות
            const cssFiles = [
                'https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/assets/owl.carousel.min.css',
                'https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/assets/owl.theme.default.min.css'
            ];
            
            cssFiles.forEach(href => {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = href;
                document.head.appendChild(link);
            });
        };

        // טעינת jQuery ו-Owl Carousel
        const loadScripts = () => {
            return new Promise((resolve) => {
                loadCSS();
                
                // בדיקה אם jQuery כבר נטען
                if (typeof window.$ !== 'undefined' && window.$ && window.$.fn) {
                    // בדיקה אם Owl Carousel כבר נטען
                    if (typeof window.$.fn.owlCarousel !== 'undefined') {
                        resolve();
                        return;
                    }
                }
                
                // טעינת jQuery אם לא נטען
                if (typeof window.$ === 'undefined' || !window.$) {
                    const jqueryScript = document.createElement('script');
                    jqueryScript.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
                    jqueryScript.onload = () => {
                        loadOwlCarousel().then(resolve);
                    };
                    document.body.appendChild(jqueryScript);
                } else {
                    loadOwlCarousel().then(resolve);
                }
            });
        };

        const loadOwlCarousel = () => {
            return new Promise((resolve) => {
                // בדיקה אם הסקריפט כבר נטען
                if (typeof window.$ !== 'undefined' && window.$ && window.$.fn && typeof window.$.fn.owlCarousel !== 'undefined') {
                    resolve();
                    return;
                }
                
                // הסר כל סקריפט קודם של owl.carousel
                const existingScripts = document.querySelectorAll('script[src*="owl.carousel"]');
                existingScripts.forEach(script => {
                    if (script.parentNode) {
                        script.parentNode.removeChild(script);
                    }
                });
                
                // השתמש ב-CDN ישירות
                const owlScript = document.createElement('script');
                owlScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js';
                
                owlScript.onload = () => {
                    resolve();
                };
                owlScript.onerror = () => {
                    resolve(); // המשך גם אם נכשל
                };
                
                document.body.appendChild(owlScript);
            });
        };

        const initCarousel = () => {
            if (!isMounted || !carouselRef.current) {
                if (retryCount < maxRetries) {
                    retryCount++;
                    setTimeout(initCarousel, 100);
                }
                return;
            }
            
            if (typeof window.$ === 'undefined' || !window.$ || !window.$.fn || typeof window.$.fn.owlCarousel === 'undefined') {
                if (retryCount < maxRetries) {
                    retryCount++;
                    setTimeout(initCarousel, 100);
                }
                return;
            }
            
            const $carousel = window.$(carouselRef.current);
            
            // בדיקה אם הקרוסלה כבר מאותחלת
            if ($carousel.hasClass('owl-loaded')) {
                try {
                    $carousel.trigger('destroy.owl.carousel');
                    $carousel.removeData();
                } catch (e) {
                    // Silent fail
                }
            }
            
            try {
                // קבלת השפה הנוכחית
                const currentLang = i18nInstance.language || 'en';
                const isRTLNow = currentLang === 'he';
                
                $carousel.owlCarousel({
                    loop: true,
                    margin: 20,
                    nav: true,
                    rtl: isRTLNow,
                    navText: [
                        '<img src="/images/town/leftarrow.png" alt="Previous" />',
                        '<img src="/images/town/rightarrow.png" alt="Next" />'
                    ],
                    dots: false,
                    items: 4,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false
                        },
                        576: {
                            items: 2,
                            nav: true
                        },
                        768: {
                            items: 3,
                            nav: true
                        },
                        992: {
                            items: 4,
                            nav: true
                        },
                        1200: {
                            items: 4,
                            nav: true
                        }
                    }
                });
                
                // Setup click handlers using jQuery after carousel initialization
                const setupClickHandlers = () => {
                    $carousel.find('.ar_singe_town_itwm').off('click').on('click', function(e) {
                        const $item = window.$(this);
                        const route = $item.data('route');
                        
                        if (route) {
                            // Check if this was a drag or a click
                            if (dragStartRef.current) {
                                const deltaX = Math.abs(e.clientX - dragStartRef.current.x);
                                const deltaY = Math.abs(e.clientY - dragStartRef.current.y);
                                
                                // If moved more than 5px, it was a drag
                                if (deltaX > 5 || deltaY > 5) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return;
                                }
                            }
                            
                            // It was a click, navigate
                            navigate(route);
                        }
                    });
                    
                    // Setup mouse down handlers
                    $carousel.find('.ar_singe_town_itwm').off('mousedown').on('mousedown', function(e) {
                        dragStartRef.current = { x: e.clientX, y: e.clientY };
                        isDraggingRef.current = false;
                    });
                    
                    // Setup mouse up handlers
                    $carousel.find('.ar_singe_town_itwm').off('mouseup').on('mouseup', function(e) {
                        dragStartRef.current = null;
                        isDraggingRef.current = false;
                    });
                };
                
                // Setup handlers after carousel is initialized
                setTimeout(() => {
                    setupClickHandlers();
                }, 200);
                
                // Re-setup handlers after carousel changes (on drag, etc.)
                $carousel.on('changed.owl.carousel', function() {
                    setupClickHandlers();
                });
                
                $carousel.on('translated.owl.carousel', function() {
                    setupClickHandlers();
                });
            } catch (error) {
                if (retryCount < maxRetries) {
                    retryCount++;
                    setTimeout(initCarousel, 150);
                }
            }
        };

        loadScripts().then(() => {
            if (isMounted) {
                // המתן שהדום יהיה מוכן
                setTimeout(() => {
                    initCarousel();
                }, 100);
            }
        });

        return () => {
            isMounted = false;
            // ניקוי carousel בעת פירוק הקומפוננטה
            if (carouselRef.current && typeof window.$ !== 'undefined' && window.$ && window.$.fn && window.$.fn.owlCarousel) {
                try {
                    const $carousel = window.$(carouselRef.current);
                    if ($carousel.hasClass('owl-loaded')) {
                        $carousel.trigger('destroy.owl.carousel');
                    }
                } catch (e) {
                    // Silent fail
                }
            }
        };
    }, [isRTL, currentLanguage, i18nInstance]);

    return (
        <div dir={isRTL ? 'rtl' : 'ltr'} style={{ display: 'flex', flexDirection: 'column', height: '100%', flex: 1 }}>
            <GoldSiverHeader previous='/home' title={t('City')}>
                <section className="ar_town_area_section" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                    <div className="container" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <div className="row" style={{ flex: 1, minHeight: 0 }}>
                            <div className="col-md-12" style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
                                <div className="ar_town_area" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                                    <div 
                                        className="ar_town_carousel_wrapper owl-carousel owl-theme" 
                                        ref={carouselRef}
                                    >
                                        {cityPlaces.map((place) => (
                                            <div 
                                                key={place.id} 
                                                className="ar_singe_town_itwm cursor-pointer"
                                                data-route={place.route}
                                                style={{ position: 'relative' }}
                                            >
                                                <img 
                                                    src={place.image} 
                                                    alt={t(place.titleKey)}
                                                    draggable={false}
                                                    onDragStart={(e) => e.preventDefault()}
                                                />
                                                <div 
                                                    style={{
                                                        position: 'absolute',
                                                        bottom: '10px',
                                                        left: '0px',
                                                        right: '0px',
                                                        textAlign: 'center',
                                                        color: 'rgb(156, 27, 66)',
                                                        fontWeight: 'bold',
                                                        fontSize: '30px',
                                                        marginBottom: '15px',
                                                        pointerEvents: 'none'
                                                    }}
                                                >
                                                    {t(place.titleKey)}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </GoldSiverHeader>
        </div>
    )
}

export default City
